import { Faqs, NavItemSnippet } from './shared'

export const newCarOffersSnippets: NavItemSnippet[] = [
  {
    heading: 'New car offers',
    snippet: 'See the latest new car offers from Marshall Motor Group',
    image:
      'https://a.storyblok.com/f/143588/216x144/d1343fc01e/marshall-cars.png',
    alt: 'Blue and silver cars on blue background',
    linkText: 'Learn more',
    href: 'https://www.cinch.co.uk/new-car-offers',
    ariaLabel: 'Navigate to new car offers page',
    trackingTitle: 'New car offers',
  },
  {
    heading: 'Why buy from Marshall?',
    snippet:
      '130+ stores, 25 automotive brands and over 115 years of expertise',
    image:
      'https://a.storyblok.com/f/143588/216x144/d6afd30805/marshall-logo.png',
    alt: 'Marshall Motor Group logo',
    linkText: 'Find out more',
    href: 'https://www.marshall.co.uk/new-cars/',
    ariaLabel: 'Navigate to sister site Marshall',
    trackingTitle: 'Marshalls',
    trackingValue: 'go to marshall.co.uk',
    externalLink: true,
  },
]

export const newCarOffersFAQs: Faqs[] = [
  {
    label: 'Which brands does Marshall Motor Group work with?',
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/27062225031709-Which-brands-does-Marshall-Motor-Group-work-with',
  },
  {
    label: 'Does cinch sell new cars?',
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/23778617731229-Does-cinch-sell-new-cars',
  },
]
